import type { BannerState } from "../../../utils/@types";

export type BannerStateRow = {
  bannerState?: BannerState;
  externalBannerChangeAt?: string | null;
  DefaultBannerURL?: string;
};

export function resolveBannerState(row: BannerStateRow): BannerState {
  if (row.bannerState) {
    return row.bannerState;
  }
  if (row.externalBannerChangeAt?.trim()) {
    return "external_change";
  }
  if (!row.DefaultBannerURL?.trim()) {
    return "no_default";
  }
  return "default";
}

export function bannerStateLabel(state: BannerState): string {
  switch (state) {
    case "no_default":
      return "No default";
    case "brand_boost":
      return "Brand-boost";
    case "external_change":
      return "External change";
    default:
      return "Default";
  }
}

export function isNonDefaultBannerState(state: BannerState): boolean {
  return state !== "default";
}

export function hasCurrentBanner(row: {
  BannerImageURL?: string;
  CurrentBannerCachedURL?: string;
}): boolean {
  return Boolean(
    row.CurrentBannerCachedURL?.trim() || row.BannerImageURL?.trim()
  );
}

/** Show CTA when default is missing or live banner drifted outside the tool. */
export function channelMissingDefaultBanner(row: {
  DefaultBannerURL?: string;
}): boolean {
  return !row.DefaultBannerURL?.trim();
}

export function channelsMissingDefaultBanner<
  T extends { ChannelId: string; DefaultBannerURL?: string },
>(channelIds: string[], rows: T[]): T[] {
  const byId = new Map(rows.map((row) => [row.ChannelId, row]));
  return channelIds
    .map((id) => byId.get(id))
    .filter((row): row is T => Boolean(row))
    .filter(channelMissingDefaultBanner);
}

export function shouldOfferAcceptCurrentAsDefault(
  row: BannerStateRow & {
    DefaultBannerURL?: string;
    BannerImageURL?: string;
    CurrentBannerCachedURL?: string;
  }
): boolean {
  if (!hasCurrentBanner(row)) {
    return false;
  }
  if (!row.DefaultBannerURL?.trim()) {
    return true;
  }
  return resolveBannerState(row) === "external_change";
}
